import {useEffect} from "react";
import {useLocation} from "react-router";

/**
 * Сбрасывает скролл в начало страницы при каждом изменении маршрута.
 * Рендерится внутри RouterProvider, поэтому useLocation() доступен.
 */
export function ScrollToTop() {
    const {pathname} = useLocation();

    useEffect(() => {
        // Прокрутка окна (стандартный scroll container)
        window.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;

        // Прокрутка внутренних overflow-контейнеров (если вёрстка использует
        // h-dvh + overflow-y-auto на внутреннем div, а не на window)
        const main = document.querySelector("main");
        if (main) {
            const scrollable = main.querySelector(".overflow-y-auto");
            if (scrollable) {
                scrollable.scrollTop = 0;
            }
        }
    }, [pathname]);

    return null;
}